import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs';
import { TenantInnerService } from '../_services/tenant-inner.service';
import { TokenService } from '../_services/token.service';

/**
 * Activates the route once the user's tenant list is loaded and the active tenant is restored, so pages that read
 * `TenantInnerService.getCurTenant()` once (e.g. its features) never see the empty state of a fresh page load.
 * Never blocks: ensureUserTenant() also emits when the user has no tenants or the request fails. Without a token
 * there is nothing to load; AuthGuard (listed before it) handles the redirect.
 */
export const TenantReadyGuard: CanActivateFn = () => {
  if (inject(TokenService).getToken() === null) {
    return true;
  }
  return inject(TenantInnerService)
    .ensureUserTenant()
    .pipe(
      take(1),
      map(() => true)
    );
};
